import { loadScripts } from '@analytics/util/scriptLoader';
import logger from '@analytics/util/logger';
import Awindow from '@analytics/types/Awindow';
import { Analytics } from '@analytics/types/Analytics';
import { KilkayaAttributes } from '@analytics/trackers/Kilkaya/types/Kilkaya';

declare let window: Awindow;

export default class Kilkaya implements Analytics {
  private kilkaya: Awindow['kilkaya'];

  public async init() {
    if (!window.kilkaya) {
      logger.error(
        'Kilkaya init called but library no found on page. Trying to load script.',
      );

      try {
        await loadScripts(
          'https://logs.kaya.delfi.ee/683d8da10049ec077c553232.js',
          {},
        );
      } catch (e) {
        console.log('Kilkaya init failed', e);
      }
    }

    this.kilkaya = window.kilkaya;
  }

  public pageView(attributes: KilkayaAttributes) {
    if (!this.kilkaya) {
      logger.error('Kilkaya pageview called but library not found on page');
      return;
    }

    // Exclude foreign language channels
    if (attributes.url && /\/(ru|en|pl)\//.test(attributes.url)) {
      return;
    }

    this.kilkaya.pageview(attributes);
  }
}
